/* ==========================================================================
   STR PAGE — Sensibo for Short-Term Rentals
   Interactive pricing, ROI calculator, FAQ accordion, and add-to-cart
   ========================================================================== */
(function () {
  'use strict';

  /* ── Pricing Data ──
     La arma la seccion con Liquid: precio de cada variante en la moneda del
     mercado y la escalera volume_discount que aplica el checkout. Montos por
     habitacion, en unidades de la moneda (no centavos). Antes era una tabla
     fija en dolares, con 20/22/25% para 5-7 habitaciones que el checkout nunca
     aplico: desde 4 cobra el escalon "4+". */
  var PRICING_SRC = window.STR_PRICING || {};
  var PRICING = (PRICING_SRC.tiers || []).map(function (t) {
    return { rooms: t.rooms, monthly: t.monthly / 100, annual: t.annual / 100, discount: t.pct };
  });

  var SAVINGS_RATE = 0.40;
  var AC_PORTION = 0.50;

  /* ── Shared State ── */
  var state = {
    rooms: 1,
    monthlyBill: 400,
    billing: 'annual'
  };

  /* ── DOM References ── */
  var els = {};

  function cacheDom() {
    els.slider = document.getElementById('str-bill-slider');
    els.billDisplay = document.getElementById('str-bill-display');
    els.monthlySavings = document.getElementById('str-monthly-savings');
    els.annualSavings = document.getElementById('str-annual-savings');
    els.payoff = document.getElementById('str-payoff');
    els.roomInput = document.getElementById('str-room-quantity');
    els.buyboxCards = document.querySelectorAll('.str-buybox__card');

    // (ROI is now part of calculator results, no separate elements needed)

    // Buybox summary
    els.ctaRooms = document.getElementById('str-cta-rooms');
    els.ctaTotal = document.getElementById('str-cta-total');
    els.addToCart = document.getElementById('str-add-to-cart');
  }

  /* ── Strings (filled by the section from the locale files; English fallback) ── */
  var I18N = window.STR_I18N || {};
  function str(key, fallback, vars) {
    var s = fallback;
    if (typeof I18N[key] === 'string') {
      /* the t filter HTML-escapes plain keys (It's -> It&#39;s); decode for textContent */
      var ta = document.createElement('textarea');
      ta.innerHTML = I18N[key];
      s = ta.value;
    }
    if (vars) {
      Object.keys(vars).forEach(function (k) { s = s.split('%' + k + '%').join(vars[k]); });
    }
    return s;
  }

  /* ── Formatting ──
     Mismo formato que el filtro money de la tienda. La seccion manda un monto
     testigo (1234567.89 en la moneda del mercado, p. ej. "$1,234,567.89",
     "€1.234.567,89" o "Dhs. 1,234,567.89") y de ahi salen simbolo, posicion y
     separadores. Sin testigo, cae a dolares como antes. */
  var MONEY = (function () {
    var sample = PRICING_SRC.money || '$1,234,567.89';
    var m = sample.match(/\d[\d.,'\s\u00a0]*\d/);
    if (!m) return { prefix: '$', suffix: '', thousands: ',', decimal: '.' };
    var digits = m[0];                       // "1,234,567.89" o "1.234.568"
    var tail = digits.match(/[^\d](\d+)$/);  // lo que sigue al ultimo separador
    var decimals = !!tail && tail[1].length === 2;
    var thousands = digits.charAt(1) === '2' ? '' : digits.charAt(1);
    /* Un formato sin decimales (el de US) igual muestra los centavos cuando el
       monto los tiene: $8.25/mo, no $8. Igual que snippets/str-money.liquid. */
    return {
      prefix: sample.slice(0, m.index),
      suffix: sample.slice(m.index + digits.length),
      thousands: thousands,
      decimal: decimals ? digits.charAt(digits.length - 3) : (thousands === '.' ? ',' : '.')
    };
  })();

  function formatMoney(amount) {
    var cents = Math.round(amount * 100);
    var whole = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.thousands);
    var frac = cents % 100;
    return MONEY.prefix + whole + (frac ? MONEY.decimal + (frac < 10 ? '0' : '') + frac : '') + MONEY.suffix;
  }

  /* La calculadora piensa la factura de luz en dolares (slider 100-1.500) y la
     muestra convertida con la tasa de Shopify, asi el "se paga solo en N meses"
     compara montos en la misma moneda que el precio. */
  var RATE = (function () {
    var r = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  })();
  function local(usd) {
    return Math.round(usd * RATE);
  }

  /* ── Slider Track Fill ── */
  function updateSliderTrack() {
    if (!els.slider) return;
    var min = parseInt(els.slider.min, 10);
    var max = parseInt(els.slider.max, 10);
    var val = parseInt(els.slider.value, 10);
    var pct = ((val - min) / (max - min)) * 100;
    els.slider.style.backgroundSize = pct + '% 100%';
  }

  /* ── Core Update ── */
  function updateAll() {
    if (!PRICING.length) return;
    var p = PRICING[Math.min(state.rooms, PRICING.length) - 1];
    var bill = state.monthlyBill;

    // Calculator outputs (savings on your total bill, not per room)
    var monthlySavings = local(bill * SAVINGS_RATE);
    var annualSavings = monthlySavings * 12;
    var annualCost = p.annual * state.rooms;
    var monthsToPayoff = monthlySavings > 0 ? Math.ceil(annualCost / monthlySavings) : 99;

    // Sync calculator room buttons
    document.querySelectorAll('.str-calc__room-btn').forEach(function (btn) {
      var r = parseInt(btn.getAttribute('data-calc-rooms'), 10);
      if (r === state.rooms) {
        btn.classList.add('str-calc__room-btn--active');
      } else {
        btn.classList.remove('str-calc__room-btn--active');
      }
    });

    if (els.billDisplay) els.billDisplay.textContent = formatMoney(local(bill));
    if (els.monthlySavings) els.monthlySavings.textContent = formatMoney(monthlySavings);
    if (els.annualSavings) els.annualSavings.textContent = formatMoney(annualSavings);
    if (els.payoff) els.payoff.textContent = monthsToPayoff === 1
      ? str('payoffOne', '%N% mo', { N: monthsToPayoff })
      : str('payoffOther', '%N% mos', { N: monthsToPayoff });

    // Slider track
    updateSliderTrack();

    // Buybox cards — highlight active + update prices (always show /mo)
    var isAnnual = state.billing === 'annual';
    els.buyboxCards.forEach(function (card) {
      var cardRooms = parseInt(card.getAttribute('data-rooms'), 10);
      var tier = PRICING[Math.min(cardRooms, PRICING.length) - 1];
      var monthlyPrice = tier.monthly;
      var annualPrice = tier.annual;
      var monthlyEquiv = Math.round(annualPrice * 100 / 12) / 100;

      // Highlight active
      if (cardRooms === state.rooms) {
        card.classList.add('str-buybox__card--active');
      } else {
        card.classList.remove('str-buybox__card--active');
      }

      // Always show monthly price, change the "billed" line
      var priceEl = card.querySelector('.str-buybox__card-price');
      var billedEl = card.querySelector('.str-buybox__card-billed');
      if (priceEl) {
        priceEl.textContent = formatMoney(isAnnual ? monthlyEquiv : monthlyPrice);
      }
      if (billedEl) {
        if (isAnnual) {
          billedEl.textContent = cardRooms > 1
            ? str('billedEach', 'Billed %PRICE%/yr each', { PRICE: formatMoney(annualPrice) })
            : str('billed', 'Billed %PRICE%/yr', { PRICE: formatMoney(annualPrice) });
        } else {
          billedEl.textContent = str('ifPaidAnnually', '%PRICE%/mo if paid annually', { PRICE: formatMoney(monthlyEquiv) });
        }
      }
    });

    // (no separate ROI section to update)

    // Buybox total — show what you actually pay
    var total = isAnnual
      ? p.annual * state.rooms
      : p.monthly * state.rooms;
    var periodEl = document.getElementById('str-cta-period');
    if (els.ctaRooms) els.ctaRooms.textContent = state.rooms;
    if (els.ctaTotal) els.ctaTotal.textContent = formatMoney(total);
    if (periodEl) periodEl.textContent = isAnnual ? str('periodYear', '/yr') : str('periodMonth', '/mo');

    // Update hidden room input
    if (els.roomInput) els.roomInput.value = state.rooms;

    // Update floating bar
    var floatingPrice = document.getElementById('str-floating-price');
    var floatingPeriod = document.getElementById('str-floating-period');
    var floatingBadge = document.getElementById('str-floating-rooms-badge');
    if (floatingPrice) floatingPrice.textContent = formatMoney(isAnnual ? Math.round(p.annual * 100 / 12) / 100 : p.monthly);
    if (floatingPeriod) floatingPeriod.textContent = str('perRoomMonth', '/mo per room');
    if (floatingBadge) floatingBadge.textContent = state.rooms === 1
      ? str('roomsOne', '%N% room', { N: state.rooms })
      : str('roomsOther', '%N% rooms', { N: state.rooms });
  }

  /* ── Event Handlers ── */
  function onSliderChange() {
    state.monthlyBill = parseInt(els.slider.value, 10);
    updateAll();
  }

  function onRoomQtyClick(e) {
    var btn = e.target.closest('.str-qty__btn');
    if (!btn) return;

    var dir = btn.getAttribute('data-dir');
    if (dir === 'up' && state.rooms < 7) {
      state.rooms++;
    } else if (dir === 'down' && state.rooms > 1) {
      state.rooms--;
    }
    updateAll();
  }

  function onRoomInputChange() {
    var val = parseInt(els.roomInput.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (val > 7) val = 7;
    state.rooms = val;
    updateAll();
  }

  /* ── Buybox Card Click ── */
  function onBuyboxCardClick(e) {
    var card = e.target.closest('.str-buybox__card');
    if (!card) return;
    var rooms = parseInt(card.getAttribute('data-rooms'), 10);
    if (rooms >= 1 && rooms <= 7) {
      state.rooms = rooms;
      updateAll();
    }
  }

  /* ── Billing Toggle ── */
  function onBillingToggle(e) {
    var btn = e.target.closest('.str-buybox__toggle-btn');
    if (!btn) return;

    var billing = btn.getAttribute('data-billing');
    if (!billing) return;

    state.billing = billing;

    // Toggle active class
    document.querySelectorAll('.str-buybox__toggle-btn').forEach(function (b) {
      b.classList.remove('str-buybox__toggle-btn--active');
    });
    btn.classList.add('str-buybox__toggle-btn--active');

    // Update billing hint
    var hint = document.getElementById('str-billing-hint');
    if (hint) {
      if (billing === 'annual') {
        hint.textContent = str('hintAnnual', "Most hosts choose annual. It's less than monthly.");
        hint.classList.remove('str-buybox__billing-hint--monthly');
      } else {
        hint.textContent = str('hintMonthly', 'Switch to annual and pay less per month.');
        hint.classList.add('str-buybox__billing-hint--monthly');
      }
    }

    updateAll();
  }

  /* ── FAQ Accordion ── */
  function initFaq() {
    var faqItems = document.querySelectorAll('.str-faq__item');
    faqItems.forEach(function (item) {
      var question = item.querySelector('.str-faq__question');
      if (!question) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('str-faq__item--open');

        // Close all others
        faqItems.forEach(function (other) {
          other.classList.remove('str-faq__item--open');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('str-faq__item--open');
        }
      });
    });
  }

  /* ── Floating Add to Cart Bar ── */
  function initFloatingAtc() {
    var mainBtn = document.getElementById('str-add-to-cart');
    var floatingBar = document.getElementById('str-floating-atc');
    var floatingBtn = document.getElementById('str-floating-btn');
    if (!mainBtn || !floatingBar) return;

    // Show/hide based on main button visibility
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          floatingBar.classList.remove('str-floating-atc--visible');
        } else {
          floatingBar.classList.add('str-floating-atc--visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainBtn);

    // Click handler — trigger main button
    if (floatingBtn) {
      floatingBtn.addEventListener('click', function () {
        mainBtn.click();
      });
    }
  }

  /* ── Buybox Image Carousel ── */
  function initCarousel() {
    var carousel = document.getElementById('str-carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.str-buybox__carousel-slide');
    var thumbs = carousel.querySelectorAll('.str-buybox__carousel-thumb');
    var current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach(function (s) { s.classList.remove('str-buybox__carousel-slide--active'); });
      thumbs.forEach(function (t) { t.classList.remove('str-buybox__carousel-thumb--active'); });
      slides[index].classList.add('str-buybox__carousel-slide--active');
      if (thumbs[index]) thumbs[index].classList.add('str-buybox__carousel-thumb--active');
      current = index;
    }

    carousel.addEventListener('click', function (e) {
      var arrow = e.target.closest('.str-buybox__carousel-arrow');
      if (arrow) {
        goTo(arrow.getAttribute('data-dir') === 'next' ? current + 1 : current - 1);
        return;
      }
      var thumb = e.target.closest('.str-buybox__carousel-thumb');
      if (thumb) {
        goTo(parseInt(thumb.getAttribute('data-index'), 10));
      }
    });
  }

  /* ── Smooth Scroll for anchor links ── */
  function initSmoothScroll() {
    document.querySelectorAll('.str-page a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Add to Cart ── */
  function addSTRToCart() {
    var btn = els.addToCart;
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    var originalText = btn.innerHTML;
    var addingEl = document.createElement('span');
    addingEl.textContent = str('adding', 'Adding...');
    btn.innerHTML = '';
    btn.appendChild(addingEl);

    /* Look up the correct variant (annual or monthly) */
    var billingKey = state.billing === 'annual' ? 'annual' : 'monthly';
    var variantData = window.STR_VARIANTS && window.STR_VARIANTS[billingKey];

    if (!variantData) {
      console.error('Variant not found for', billingKey);
      btn.innerHTML = originalText;
      btn.disabled = false;
      return;
    }

    var cartElement = document.querySelector('cart-drawer');

    /* A/B test hook: an experiment (e.g. Convert) can set window.STR_SENSOR_PROP
       to tag the order with a line item property (e.g. sensor count) so ops can
       fulfill accordingly. Inert unless the flag is set — default behavior is
       unchanged. */
    var lineItem = {
      id: variantData.id,
      quantity: state.rooms,
      selling_plan: variantData.sellingPlanId
    };
    if (window.STR_SENSOR_PROP) {
      lineItem.properties = window.STR_SENSOR_PROP;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [lineItem],
        sections: cartElement && cartElement.getSectionsToRender
          ? cartElement.getSectionsToRender().map(function (s) { return s.section || s.id; })
          : []
      })
    })
    .then(function (response) {
      if (response.ok) {
        return response.json().then(function (data) {
          btn.innerHTML = originalText;
          btn.disabled = false;
          if (cartElement && cartElement.renderContents) {
            cartElement.renderContents(data);
          } else {
            window.location.href = '/cart';
          }
        });
      } else {
        console.error('Error adding to cart');
        btn.innerHTML = originalText;
        btn.disabled = false;
      }
    })
    .catch(function () {
      console.error('Network error adding to cart');
      btn.innerHTML = originalText;
      btn.disabled = false;
    });
  }

  /* ── Calculator Room Buttons ── */
  function onCalcRoomClick(e) {
    var btn = e.target.closest('.str-calc__room-btn');
    if (!btn) return;

    var rooms = parseInt(btn.getAttribute('data-calc-rooms'), 10);
    if (rooms >= 1 && rooms <= 7) {
      state.rooms = rooms;

      // Update active state on calc buttons
      document.querySelectorAll('.str-calc__room-btn').forEach(function (b) {
        b.classList.remove('str-calc__room-btn--active');
      });
      btn.classList.add('str-calc__room-btn--active');

      updateAll();
    }
  }

  /* ── Initialize ── */
  function init() {
    cacheDom();

    // Slider
    if (els.slider) {
      els.slider.addEventListener('input', onSliderChange);
    }

    // Calculator room buttons
    var calcRooms = document.querySelector('.str-calc__rooms');
    if (calcRooms) {
      calcRooms.addEventListener('click', onCalcRoomClick);
    }

    // Buybox card click
    var buyboxCards = document.querySelector('.str-buybox__cards');
    if (buyboxCards) {
      buyboxCards.addEventListener('click', onBuyboxCardClick);
    }

    // Billing toggle
    var billingToggle = document.querySelector('.str-buybox__toggle');
    if (billingToggle) {
      billingToggle.addEventListener('click', onBillingToggle);
    }

    // Add to cart button
    if (els.addToCart) {
      els.addToCart.addEventListener('click', addSTRToCart);
    }

    // Floating ATC bar
    initFloatingAtc();

    // FAQ accordion
    initFaq();

    // Image carousel
    initCarousel();

    // Smooth scroll
    initSmoothScroll();

    // Rango del slider en la moneda del mercado
    var range = document.querySelectorAll('.str-calc__slider-range span');
    if (els.slider && range.length === 2) {
      range[0].textContent = formatMoney(local(parseInt(els.slider.min, 10)));
      range[1].textContent = formatMoney(local(parseInt(els.slider.max, 10)));
    }

    // Initial render
    updateAll();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
